/* Quick add-to-cart from a product card (single-variant products only).
   Mirrors the PDP flow in product.js: POST /cart/add.js → re-read /cart.js → open the drawer.
   Delegated once, globally, so it covers cards on every surface (collection, search, home, recs). */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    btn.disabled = true;
    // Support one or more label spans (e.g. desktop + mobile variants) so the
    // "Agregando…/¡Agregado!" feedback updates whichever one is visible.
    var labels = btn.querySelectorAll('[data-label]');
    if (!labels.length) labels = btn.querySelectorAll('span');
    var originals = [];
    labels.forEach(function (l) { originals.push(l.textContent); });
    function setLabels(t) { labels.forEach(function (l) { l.textContent = t; }); }
    function restoreLabels() { labels.forEach(function (l, i) { l.textContent = originals[i]; }); }
    setLabels('Agregando…');
    var root = (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) { throw new Error(res.data.description || 'Error'); }
        return fetch(root + 'cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        var badgeCount = window.VLX ? window.VLX.realCount(cart) : cart.item_count;
        document.querySelectorAll('[data-cart-count]').forEach(function (c) { c.textContent = badgeCount; });
        if (window.VlxCartDrawer && typeof window.VlxCartDrawer.open === 'function') {
          window.VlxCartDrawer.open(cart);
        }
        setLabels('¡Agregado!');
        setTimeout(function () { restoreLabels(); btn.disabled = false; }, 1400);
      })
      .catch(function () {
        restoreLabels();
        btn.disabled = false;
        window.location.href = btn.getAttribute('data-product-url') || '/cart';
      });
  });
})();
